interface ScreeningQuestionProgressCountProps {
  progressCount: number;
  progressLimit: number;
  t: Record<string, string>;
}

function ScreeningQuestionProgressCount({
  progressCount,
  progressLimit,
  t,
}: ScreeningQuestionProgressCountProps) {
  return (
    <p className="font-medium text-sm text-dark-text absolute -top-10 -right-2 opacity-50">
      {`${t.question} ${progressCount} / ${progressLimit}`}
    </p>
  );
}

export default ScreeningQuestionProgressCount;
